import { css } from "@emotion/css";
import Link from "evcharging/components/Link";
import LinkButton from 'evcharging/components/LinkButton';
import { CONTACT_US_ID } from 'evcharging/app/seo/urls';
import Spacer from 'evcharging/components/Spacer';
import useTheme from 'evcharging/hooks/useTheme';
import { Theme } from 'evcharging/app/themes';
import InlineGap from 'evcharging/components/InlineGap';
import LinkSecondaryButton from 'evcharging/components/LinkSecondaryButton';

export const ServiceHeader = ({
  serviceName,
  title,
  description,
  bgImage
}) => {
  const theme = useTheme();
  const styles = createStyles(theme);

  return (
    <div className={styles.root} style={{ backgroundImage: `url(${bgImage})` }} >
      <div className={styles.gradient} />
      <div className={styles.container}>
        <ul className={styles.breadcrumbs}>
          <li><Link href="/">Energy 5</Link></li>
          <li>/</li>
          <li><b>{serviceName}</b></li>
        </ul>
        <Spacer value={140} mobile={48} />
        <div className={styles.titleContainer}>
          <h6>{serviceName}</h6>
          <h1>{title}</h1>
          <p>{description}</p>
          <Spacer value={32}/>
          <LinkButton href={`#${CONTACT_US_ID}`}>
            Get free consultation
          </LinkButton>
          <InlineGap desktop={12} />
          {serviceName === 'Thermostat' && (
            <LinkSecondaryButton href={`/thermostats/marketplace`}>
              Marketplace
            </LinkSecondaryButton>
          )}
        </div>
        <Spacer value={220} mobile={36} />
      </div>
    </div>
  )
}

const createStyles = (theme: Theme) => ({
  root: css`
    position: relative;
    margin-top: 98px;
    background-size: cover;
    @media (max-width: 960px) {
      margin-top: 68px;
    }
  `,
  gradient: css`
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 0;
    background: linear-gradient(90deg, rgba(0,0,0,1) 0%, rgba(255,255,255,0) 100%);
  `,
  container: css`
    position: relative;
    max-width: 1280px;
    margin: auto;
    padding: 40px 15px;
    z-index: 1;
  `,
  title: css`
    padding-top: 28px;
    font-weight: 700;
    font-size: 32px;
    line-height: 130%;
    text-align: center;
    color: #252c32;
  `,
  breadcrumbs: css`
    display: flex;
    gap: 8px;
    color: white;
    list-style: none;
    font-size: 16px;
    line-height: 24px;
    
    a {
      color: white
    } 
  `,
  titleContainer: css`
    max-width: 50%;
    white-space: pre-line;

    @media (max-width: 960px) {
      max-width: 100%;
    }
    
    h6 {
      margin-bottom: 12px;
      font-size: 18px;
      font-weight: 700;
      line-height: 27px;
      color: #F9C106;
    }
    
    h1 {
      margin-bottom: 18px;
      font-size: 48px;
      font-weight: 700;
      line-height: 58px;
      color: white;
      ${theme.breakpoints.mobile.down} {
        font-size: 32px;
        line-height: 36px;
      }
    }
    
    p {
      font-size: 18px;
      font-weight: 400;
      line-height: 27px;
      color: white;
    }
  `,
});
